/**
 * @generated SignedSource<<d75d26a545625da6eaa61c622887eb4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AutomatedNotificationType = "ABANDONED_BROWSE" | "ABANDONED_CART" | "ABANDONED_CHECKOUT" | "REENGAGEMENT" | "WELCOME_SERIES" | "%future added value";
export type CDPAudienceType = "LIST" | "SEGMENT" | "%future added value";
export type CDPType = "EMARSYS" | "KINN" | "KLAVIYO" | "OMETRIA" | "SHOPIFY" | "%future added value";
export type GraphQLAutomatedNotificationInput = {
  audiences?: ReadonlyArray<GraphQLCDPAudienceInput> | null;
  delaySeconds: number;
  id?: string | null;
  isEnabled?: boolean | null;
  landingPath?: string | null;
  message?: string | null;
  notifType: AutomatedNotificationType;
  resendEnabled?: boolean | null;
  title?: string | null;
};
export type GraphQLCDPAudienceInput = {
  audienceId: string;
  audienceName: string;
  audienceType: CDPAudienceType;
  cdpType: CDPType;
};
export type useAppClipNotificationsUpdateMutation$variables = {
  appConfigId: string;
  notifications: ReadonlyArray<GraphQLAutomatedNotificationInput>;
};
export type useAppClipNotificationsUpdateMutation$data = {
  readonly updateAppClipAutomatedNotifications: {
    readonly appConfig: {
      readonly appClipAutomatedNotifications: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly delaySeconds: number;
            readonly id: string;
            readonly isEnabled: boolean;
            readonly landingPath: string | null;
            readonly message: string;
            readonly notifType: AutomatedNotificationType;
            readonly title: string;
          };
        }>;
      };
      readonly id: string;
    };
  };
};
export type useAppClipNotificationsUpdateMutation = {
  response: useAppClipNotificationsUpdateMutation$data;
  variables: useAppClipNotificationsUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appConfigId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "notifications"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "appConfigId",
    "variableName": "appConfigId"
  },
  {
    "kind": "Variable",
    "name": "notifications",
    "variableName": "notifications"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "BrandAppConfigType",
  "kind": "LinkedField",
  "name": "appConfig",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLAutomatedNotificationConnection",
      "kind": "LinkedField",
      "name": "appClipAutomatedNotifications",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLAutomatedNotificationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLAutomatedNotification",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "notifType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "message",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isEnabled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "delaySeconds",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "landingPath",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAppClipNotificationsUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "updateAppClipAutomatedNotifications",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAppClipNotificationsUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "updateAppClipAutomatedNotifications",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ce908212b17ef410cb742daca745b8dd",
    "id": null,
    "metadata": {},
    "name": "useAppClipNotificationsUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation useAppClipNotificationsUpdateMutation(\n  $appConfigId: ID!\n  $notifications: [GraphQLAutomatedNotificationInput!]!\n) {\n  updateAppClipAutomatedNotifications(appConfigId: $appConfigId, notifications: $notifications) {\n    appConfig {\n      id\n      appClipAutomatedNotifications {\n        edges {\n          node {\n            id\n            notifType\n            title\n            message\n            isEnabled\n            delaySeconds\n            landingPath\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "700a455ded599acdd6af836e1c12c2ef";

export default node;
